import { NgClass, NgFor, NgIf, NgOptimizedImage } from '@angular/common';
import { afterNextRender, Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DynamicModule } from 'ng-dynamic-component';
import { Product } from 'src/app/classes/product';
import { CarouselComponent } from 'src/app/components/carousel/carousel.component';
import { CollectionItemComponent } from 'src/app/components/collection-item/collection-item.component';
import { StoryblokLinkDirective } from 'src/app/directive/storyblok-link.directive';
import { StoryblokDirective } from 'src/app/directive/storyblok.directive';
import { MercuryService } from 'src/app/service/mercury.service';

@Component({
  selector: 'app-collection',
  standalone: true,
  imports: [
    NgFor,
    NgIf,
    NgClass,
    RouterModule,
    DynamicModule,
    StoryblokLinkDirective,
    StoryblokDirective,
    NgOptimizedImage,
    CarouselComponent,
    CollectionItemComponent,
  ],
  templateUrl: './collection.component.html',
  styleUrl: './collection.component.scss',
})
export class CollectionComponent {
  @Input() title!: string;
  @Input() link: any;
  @Input() link_text: string = '';
  @Input() link_style: string = '';
  @Input() colour: string = 'secondary';
  @Input() zone_shortcode: string = '';
  @Input() _editable!: string;
  @Input() _uid!: string;
  @Input() component!: string;

  options = {
    0: { slides: 1.6, nav: true },
    991: { slides: 3, nav: true },
  };

  products: Product[] = [];

  constructor(private mercuryService: MercuryService) {
    afterNextRender(() => {
      let handle = 'all';
      if (this.link?.url) {
        handle = this.link.url.includes('/collections/')
          ? this.link.url.split('/collections/')[1].split('?')[0]
          : handle;
      }
      if (this.zone_shortcode) {
        this.mercuryService
          .getZoneByShortcode(this.zone_shortcode)
          .subscribe((data) => {
            this.products = data.products;
            this.products.sort(() => Math.random() - 0.5);
          });
      } else {
        this.mercuryService.getFilteredCollection(handle).subscribe((data) => {
          this.products = data.products;
          this.products.sort(() => Math.random() - 0.5);
        });
      }
    });
  }
}
